import React, {Component} from 'react'
import PropTypes from 'prop-types'
import ItemSideDefault from './ItemSideDefault'
import ItemSideImage from './ItemSideImage'

class ItemSide extends Component {
    _renderLayout = () => {
        const {layout, ...rest} = this.props

        if ('default' === layout) {
            return <ItemSideDefault {...rest}/>
        } else if ('image' === layout) {
            return <ItemSideImage {...rest}/>
        }

        return ''
    }

    render() {
        const content = this._renderLayout()

        return (
            <div className='ItemSide'>
                {content}
            </div>
        )
    }
}

ItemSide.defaultProps = {
    layout: 'default',
}

ItemSide.propTypes = {
    layout: PropTypes.oneOf(['default', 'image']),
}

export default ItemSide
